import * as actionTypes from '../consts/actionTypes';

export function getEmergencyNumbers() {
    return {
        type: actionTypes.GET_EMERGENCY_NUMBERS,
        payload: ''
    };
}